// 埋点页面链接：https://stream.jd.com/ddrx/#/requirement/32416
// WARNING!!! 请勿手动修改此文件，如需修改请在子午线平台变更后，执行npm run track-init 32416
import { eventTrackingUtils } from '@/utils/eventTrack/eventTrackingUtils';
interface IExpoTrackParamsRecord {
  /** Joybuy plus entry */
  joybuy_plus_entry_Exp: {
    /** buttonstatus On-开,Off-关 */
    status: Array<'On' | 'Off'>;
  };
  /** plus plan Exp */
  plus_plan_Exp: undefined;
  /** checkout page */
  place_order_button_Exp: undefined;
  /** Order success */
  order_success_Exp: undefined;
  /** student verify page */
  student_verfiy_submit_button: undefined;
  /** wait for verification page */
  wait_for_verification_page: undefined;
  /** subscription cancel button */
  subscription_cancel_button_Exp: undefined;
  /** subscription cancel reason */
  subscription_cancel_reason_Exp: undefined;
  /** plus benefit landing page (购后) */
  plus_benefit_landingpage_Exp: undefined;
}

const EXPOSURE_RECORD: Readonly<Record<keyof IExpoTrackParamsRecord, string>> = Object.freeze({
  /** Joybuy plus entry */
  joybuy_plus_entry_Exp: 'joybuy_plus_entry_Exp',
  /** plus plan Exp */
  plus_plan_Exp: 'plus_plan_Exp',
  /** checkout page */
  place_order_button_Exp: 'place_order_button_Exp',
  /** Order success */
  order_success_Exp: 'order_success_Exp',
  /** student verify page */
  student_verfiy_submit_button: 'student_verfiy_submit_button',
  /** wait for verification page */
  wait_for_verification_page: 'wait_for_verification_page',
  /** subscription cancel button */
  subscription_cancel_button_Exp: 'subscription_cancel_button_Exp',
  /** subscription cancel reason */
  subscription_cancel_reason_Exp: 'subscription_cancel_reason_Exp',
  /** plus benefit landing page (购后) */
  plus_benefit_landingpage_Exp: 'plus_benefit_landingpage_Exp',
});

interface IClickTrackParamsRecord {
  /** Joybuy plus entry */
  joybuy_plus_entry_Click: {
    /** buttonstatus 1-会员,2-非会员 */
    status: '1' | '2';
  };
  /** student button */
  student_button_Click: undefined;
  /** checkout button */
  checkout_button_Click: {
    /** buttonstatus On-开,Off-关 */
    status: '1' | '2';
  };
  /** checkout page */
  place_order_Click: undefined;
  /** student verfiy page */
  student_verfiy_button_Click: undefined;
  /** verification resend */
  verification_resend_Click: undefined;
  /** subscription cancel button */
  subscription_cancel_button_Click: undefined;
  /** subscription cancel reason */
  subscription_cancel_continuebutton_Click: undefined;
}

const sendClickTrack = {
  /** 点击事件上报-Joybuy plus entry */
  joybuy_plus_entry_Click: (json_param: IClickTrackParamsRecord['joybuy_plus_entry_Click']) => {
    eventTrackingUtils.submitCL({ event_id: 'joybuy_plus_entry_Click', json_param });
  },
  /** 点击事件上报-student button */
  student_button_Click: () => {
    eventTrackingUtils.submitCL({ event_id: 'student_button_Click' });
  },
  /** 点击事件上报-checkout button */
  checkout_button_Click: (json_param: IClickTrackParamsRecord['checkout_button_Click']) => {
    eventTrackingUtils.submitCL({ event_id: 'checkout_button_Click', json_param });
  },
  /** 点击事件上报-checkout page */
  place_order_Click: () => {
    eventTrackingUtils.submitCL({ event_id: 'place_order_Click' });
  },
  /** 点击事件上报-student verfiy page */
  student_verfiy_button_Click: () => {
    eventTrackingUtils.submitCL({ event_id: 'student_verfiy_button_Click' });
  },
  /** 点击事件上报-verification resend */
  verification_resend_Click: () => {
    eventTrackingUtils.submitCL({ event_id: 'verification_resend_Click' });
  },
  /** 点击事件上报-subscription cancel button */
  subscription_cancel_button_Click: () => {
    eventTrackingUtils.submitCL({ event_id: 'subscription_cancel_button_Click' });
  },
  /** 点击事件上报-subscription cancel reason */
  subscription_cancel_continuebutton_Click: () => {
    eventTrackingUtils.submitCL({ event_id: 'subscription_cancel_continuebutton_Click' });
  },
};

export { EXPOSURE_RECORD, sendClickTrack };
export type { IExpoTrackParamsRecord };
